import styled, { css } from 'styled-components';
import { AVideoAspectRatio } from './AVideo.types';

export const getAspectRatioValue = (ratio: AVideoAspectRatio): string => ratio.replace(':', ' / ');

interface BrightcoveWrapperProps {
  $aspectRatio?: AVideoAspectRatio;
}

/**
 * Wrapper for the Brightcove player.
 *
 * When $aspectRatio is provided, CSS aspect-ratio constrains the container
 * and the inner .video-js is absolutely positioned to fill it.
 * Brightcove's CDN stylesheet injects a hardcoded padding-top rule that
 * overrides Video.js responsive sizing, so !important on the inner element
 * is required to let the CSS wrapper win.
 */
export const BrightcoveWrapper = styled.div<BrightcoveWrapperProps>`
  inline-size: 100%;
  position: relative;

  ${({ $aspectRatio }) =>
    $aspectRatio &&
    css`
      aspect-ratio: ${getAspectRatioValue($aspectRatio)};

      .video-js {
        position: absolute;
        inset: 0;
        inline-size: 100% !important;
        block-size: 100% !important;
        padding-block-start: 0 !important;
      }
    `}
`;

export const VideoWrapper = styled.div<{ $aspectRatio?: AVideoAspectRatio }>`
  position: relative;
  inline-size: 100%;
  aspect-ratio: ${({ $aspectRatio }) => ($aspectRatio ? getAspectRatioValue($aspectRatio) : '16 / 9')};
  overflow: hidden;
  border-radius: var(--t-images-border-radius, 14px);
`;

export const VideoElement = styled.video`
  inline-size: 100%;
  block-size: 100%;
  object-fit: cover;
  display: block;
`;
